module.exports = __webpack_public_path__ + "img/AllActive.f61df5f4.svg";